// Import the mixins
import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'

// Import firebase
import { propertiesModel } from '@/firebase/firebase-config'

export const GetUnit = {

    /*
	**  Register the mixins
	*/

	mixins: [

        BugsnagService

    ],

    /*
	**  Set up the data
	*/

	data: () => ({

        unit: null

    }),

    /*
	**  Methods
    */
    
    methods: {

        getUnitHandler: function(unit_id) {

            try {

                // Get the doc
                propertiesModel.doc(this.$route.params.id).collection('units').doc(unit_id).get()
                .then(doc => {

                    if (!doc.exists) return;

                    /*
                    **  Set the doc prop
                    **  @prop: @here
                    */

                    this.unit = doc.data();

                })
                .catch(error => {

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */
                
                    this.reportAuthBugsnagError({
                        title: 'Get Unit from Firestore',
                        errorType: 'Firestore Database',
                        section: 'Events/Units',
                        uid: 'KMPeP71sHDKuI6yqi8mv',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
            
                this.reportAuthBugsnagError({
                    title: 'Unable to Query for Unit from Firestore',
                    errorType: 'Firestore Database',
                    section: 'Events/Units',
                    uid: 'A4E8x5Q6juqUITvcTrmo',
                    error: e
                });

            }

        }

    }

}